import { ChipButton } from '@scope/scope-one-ui/core';
import styled, { css } from 'styled-components';
import { COLORS } from '@scope/scope-one-ui/theme';
import { StyledChipButtonProps } from './ESGScoresOverTime.d';

export const StyledChipButton = styled(ChipButton)<StyledChipButtonProps>(
  ({ pressed }) => css`
    &:enabled {
      background-color: ${pressed ? COLORS.secondary.text : COLORS.secondary.hover};
      color: ${pressed ? COLORS.secondary.hover : COLORS.secondary.text};
    }
  `,
);
